export default __webpack_public_path__ + "993ffc8383385263c291cb52ea03366f.png";